import Vue from 'vue'
import Router from 'vue-router'

/**
 * 重写路由的push方法
 */
const routerPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(error => error)
}
Vue.use(Router)

let routes = [
  {
    path: '/login',
    name: 'login',
    component: resolve =>
      require(['../components/pms/login/login.vue'], resolve),
    meta: {
      title: '用户管理'
    }
  },
  {
    path: '/',
    component: resolve => require(['../pages/pms/index.vue'], resolve),
    meta: {
      title: '工作流'
    },
    children: [
      {
        path: '/',
        name: 'list',
        component: resolve => require(['../pages/pms/activity/list.vue'], resolve)
      }
    ]
  }
]
export default new Router({
  mode: 'history',
  linkActiveClass: 'router-link-active',
  routes: routes
})



// WEBPACK FOOTER //
// ./src/router/index.js